<template>
  <div>
    <div
      class="p-0"
      v-for="account in accounts"
      v-bind:key="account.account_id"
    >
      <b-row class="mb-2">
        <div class="ml-3 mr-1 text-left" >
          <img
            v-if="record.institution_logo"
            :src="`data:image/png;base64,${record.institution_logo}`"
            class="institutionLogo"
          />
          <font-awesome-icon v-else icon="plaid-icon" size="2x"/>
        </div>
        <b-col class="col-5 pl-0 ml-0 text-left">
          <span class="h4">{{ record.institution_name || record.institution_id }}</span>
          <p class="text-secondary mb-0">{{ account.mask || '-' }}</p>
        </b-col>
        <b-col class="col-6">
          <div class="font-italic text-right">
            {{ account.balances.available | currency }}
          </div>
          <div class="text-secondary text-right">Available balance</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-3">
          <span class="font-weight-bold">Name</span>
          <p>{{ account.owners[0].names[0] || '-'}}</p>
        </b-col>
        <b-col class="col-3">
          <span class="font-weight-bold">Email</span>
          <p>{{ account.owners[0].emails[0].data || '-' }}</p>
        </b-col>
        <b-col class="col-3">
          <span class="font-weight-bold">Cell Phone</span>
          <p>{{ account.owners[0].phone_numbers[0].data || '-'}}</p>
        </b-col>
        <b-col class="col-3">
          <span class="font-weight-bold">Address</span>
          <p class="mb-0">{{ account.owners[0].addresses[0].street || ''}}</p>
          <p>
            {{ account.owners[0].addresses[0].city || ''}},
            {{ account.owners[0].addresses[0].region || ''}},
            {{ account.owners[0].addresses[0].country || ''}}
          </p>
        </b-col>
      </b-row>
      <hr/>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
    accounts: {
      type: Array,
      required: true,
    },
    assetReportId: {
      type: String,
      required: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plaid/PlaidItem.vue